import { render, staticRenderFns } from "./PanoramicaNew.vue?vue&type=template&id=60a680e8&scoped=true&"
import script from "./PanoramicaNew.vue?vue&type=script&lang=js&"
export * from "./PanoramicaNew.vue?vue&type=script&lang=js&"
import style0 from "./PanoramicaNew.vue?vue&type=style&index=0&id=60a680e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a680e8",
  null
  
)

export default component.exports